import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { getAdminRoleAccess } from "../access/adminAccess";
import { getAdminDefaultRoute } from "../access/getAdminDefaultRoute";

export default function ProtectedAdminRoute() {
  const { isAuth, loading, user } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!isAuth || !user) {
    return <Navigate to="/background/gate/login" replace state={{ from: location }} />;
  }

  if (user?.type !== "admin") {
    return <Navigate to="/login" replace />;
  }

  const roleAccess = getAdminRoleAccess(user?.role);
  if (!roleAccess) {
    return <Navigate to="/background/gate/login" replace />;
  }

  const currentPath = location.pathname;
  const isAllowed = roleAccess.routes.includes(currentPath);

  if (!isAllowed) {
    return <Navigate to={getAdminDefaultRoute(user)} replace />;
  }

  return <Outlet />;
}
